if (!customElements.get('top-bar')) {
  customElements.define('top-bar', class TopBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      console.log('top-bar loaded');
      let _this = this;
      this.initializeSlider();
      /*window.addEventListener('resize', _this.initializeSlider());*/
    }

    initializeSlider() {
      // Validate jQuery and Slick are loaded
      if (typeof $ === 'undefined' || typeof $.fn.slick === 'undefined') {
        console.error('Top bar slider requires jQuery and Slick to be loaded');
        return false;
      }

      let $slider  = $('.top-bar__slider');
      if($slider.hasClass('slick-initialized')) {
        $slider.slick('refresh');
        return false;
      } else {
        $slider.slick({
          autoplay: true,
          autoplaySpeed: 5000,
          dots: false,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev top-bar__arrow top-bar__arrow--prev" aria-label="Previous"><span class="sr-only">Previous</span></button>',
          nextArrow: '<button type="button" class="slick-next top-bar__arrow top-bar__arrow--next" aria-label="Next"><span class="sr-only">Next</span></button>',
          draggable: true,
          infinite: true,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 0
        });
      }
    }
  })
}
